import React, { useState, useEffect, useRef } from 'react';
import MaxEnquiry from './MaxEnquiry';
import MaxActivated from './MaxActivated';
import MaxNotActivated from './MaxNotActivated';
import MaxError from './MaxError';
import { subInfo } from '../../Services/subInfo';
import { translations } from '../Text/translations';
import { buildLogoutUrl } from '../../../../../utils/authHelper';
import '../../css/max.scss';
import { setTrackingCookie } from '../../Utils/TrackingUtil';
import maxActivationImage from '../../assets/max/Max-Activation.png';

// Brand Logos
import hboLogo from '../../assets/max/HBO logo.svg';
import warnerLogo from '../../assets/max/Warner_Bros_logo.svg';
import dcLogo from '../../assets/max/DC logo.svg';
import universalLogo from '../../assets/max/Universal_Pictures_logo 1.svg';
import paramountLogo from '../../assets/max/Paramount_Pictures_Corporation_logo.svg';
import harryPotterLogo from '../../assets/max/Harry_Potter_wordmark.svg';

// Poster Images
import supermanPoster from '../../assets/max/posters/Superman.png';
import harryPotterPoster from '../../assets/max/posters/HarryPotter-max.png';
import euphoriaPoster from '../../assets/max/posters/Euphoria-en.png';
import thePittPoster from '../../assets/max/posters/The Pitt.png';
import twlPoster from '../../assets/max/posters/TWL S3.png';
import tlousPoster from '../../assets/max/posters/TLOUS2.png';

// Language Specific Posters
import oneBattlePosterEn from '../../assets/max/posters/One-Battle-After-Another-en.png';
import oneBattlePosterZh from '../../assets/max/posters/One-Battle-After-Another-zh.png';

import kitchenSoldierPosterEn from '../../assets/max/posters/The-Legend-of-Kitchen-Soldier-en.png';
import kitchenSoldierPosterZh from '../../assets/max/posters/The-Legend-of-Kitchen-Soldier-zh.png';

import wickedPosterEn from '../../assets/max/posters/Wicked-For-Good-en.png';
import wickedPosterZh from '../../assets/max/posters/Wicked-For-Good-zh.png';

import houseDragonPosterEn from '../../assets/max/posters/House-of-the-Dragon-S3-en.png';
import houseDragonPosterZh from '../../assets/max/posters/House-of-the-Dragon-S3-zh.png';

// Video Tutorials and Overlays
import videoSrcEn from '../../assets/max/media/HBO-MAX-tutorial-en.mp4';
import videoSrcZh from '../../assets/max/media/HBO-MAX-tutorial-zh.mp4';

import videoPosterSrcEn from '../../assets/max/video-overlay-en.jpg';
import videoPosterSrcZh from '../../assets/max/video-overlay-zh.jpg';

import hbomaxAppLogo from '../../assets/max/hbomax-applogo.png';
import hbomaxDevices from '../../assets/max/hbomax-devices.png';
import nowh1box from '../../assets/max/nowh1box.png';
import nowh2box from '../../assets/max/nowh2box.png';

// Local assets for Download NowTV block
import nowTVAppIcon from '../../../../../images/Blog/logo/Now-TV-app-icon.svg';
import iOSAppStoreImg from '../../../../../images/Blog/logo/iOS-app-store-en.svg';
import googlePlayStoreImg from '../../../../../images/Blog/logo/Google-Play-store-en.svg';
import samsungTizenImg from '../../../../../images/Blog/logo/samsung-tizen.svg';
import LGSmartTVImg from '../../../../../images/Blog/logo/LG-smart-TV.png';
import androidtvtvImg from '../../../../../images/Blog/logo/androidtv-logo.svg';
import PanasonicFiretvImg from '../../../../../images/Blog/logo/Panasonic-firetv.png';

const Max = ({
  currentLang = 'en',
  nowSessionId,
  loginUrl,
  fsaType,
  fsa,
  cust_type,
  mobilenowid,
  emailnowid,
  nickname,
  novaXIndicator,
  verifiedDate
}) => {
  const [subscribedInd, setSubscribedInd] = useState('');
  const [activationStatus, setActivationStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const [learnMoreUrl, setLearnMoreUrl] = useState('');
  const [activeTab, setActiveTab] = useState('h1h2stb');
  const [boxModelOpen, setBoxModelOpen] = useState(false);
  const [deviceType, setDeviceType] = useState('desktop');
  let isEmailVerified = Boolean(verifiedDate);

  const leftTrackRef = useRef(null);
  const rightTrackRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    if (loading) {
      document.body.classList.add('page-load');
    } else {
      document.body.classList.remove('page-load');
    }
  }, [loading]);

  useEffect(() => {
    if (nowSessionId) {
      if (!fsa) {
        setSubscribedInd('N');
        setLoading(false);
      } else {
        Promise.all([
          subInfo('HBO')
        ]).then(([subInfoResponse]) => {
          if (subInfoResponse.subscribedInd)
            setSubscribedInd(subInfoResponse.subscribedInd);
          if (subInfoResponse.activationStatus)
            setActivationStatus(subInfoResponse.activationStatus);
          setLoading(false);
        }).catch((error) => {
          setLoading(false);
        });
      }

      if(!fsa) {
        setLearnMoreUrl('/get-started/?libid=L50001');
      } else {
        setLearnMoreUrl(`https://ssp.nowtv.now.com/choose-plan?libid=L50001&lang=${currentLang === 'en' ? 'en' : 'zh'}`);
      }
    } else {
      setLoading(false);
    }
  }, [fsaType, fsa, nowSessionId, cust_type, novaXIndicator, currentLang]);

  useEffect(() => {
    setTrackingCookie();
  }, []);

  const adjustTrackDurations = () => {
    if (leftTrackRef.current) {
      const oneSetWidth = leftTrackRef.current.offsetWidth / 2;
      if (oneSetWidth > 0) {
        const speed = 40; // px per second
        const duration = oneSetWidth / speed;
        leftTrackRef.current.style.animationDuration = `${duration}s`;
      }
    }
    if (rightTrackRef.current) {
      const oneSetWidth = rightTrackRef.current.offsetWidth / 2;
      if (oneSetWidth > 0) {
        const speed = 40; // px per second
        const duration = oneSetWidth / speed;
        rightTrackRef.current.style.animationDuration = `${duration}s`;
      }
    }
  };

  useEffect(() => {
    if (!nowSessionId) {
      adjustTrackDurations();
      window.addEventListener('resize', adjustTrackDurations);

      const timer = setTimeout(adjustTrackDurations, 600);

      return () => {
        window.removeEventListener('resize', adjustTrackDurations);
        clearTimeout(timer);
      };
    }
  }, [nowSessionId, currentLang]);

  // Suppress development-only ResizeObserver loop overlay errors during browser resize
  useEffect(() => {
    const handleResizeObserverError = (e) => {
      if (e.message && (
        e.message.includes('ResizeObserver loop completed with undelivered notifications') ||
        e.message.includes('ResizeObserver loop limit exceeded')
      )) {
        e.stopImmediatePropagation();
      }
    };
    window.addEventListener('error', handleResizeObserverError);
    return () => window.removeEventListener('error', handleResizeObserverError);
  }, []);

  const handleLogonButtonClick = () => {
    window.location.href = loginUrl;
  };

  const handleFindYourSubscriptionClick = () => {
      const callback = encodeURIComponent(window.location.href);
      const targetRedirect = currentLang === 'en'
        ? `https://tvbinding.now.com/verifynowidpa/en/index.jsp?callback=${callback}`
        : `https://tvbinding.now.com/verifynowidpa/zh/index.jsp?callback=${callback}`;
  
      if (typeof window !== 'undefined') {
        sessionStorage.removeItem('redemptionCode');
      }
  
      window.location.href = buildLogoutUrl(currentLang, targetRedirect);
    };

  const handleLearnMoreHereClick = () => {
    currentLang === 'en' ? window.open("https://www.nowe.com/serviceenhancementhbomax?locale=en") : window.open("https://www.nowe.com/serviceenhancementhbomax?locale=zh");
  };

  const handleSupportedDevicesClick = () => {
    const url = currentLang === 'en'
      ? 'https://help.hbomax.com/hk-en/Answer/Detail/000002506'
      : 'https://help.hbomax.com/hk/Answer/Detail/000002506';
    window.open(url, '_blank');
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const userAgent = window.navigator.userAgent;
      if (/iPad|iPhone|iPod/.test(userAgent)) {
        setDeviceType('ios');
      } else if (/Android/.test(userAgent)) {
        setDeviceType('android');
      } else {
        setDeviceType('desktop');
      }
    }
  }, []);

  useEffect(() => {
    if (videoRef.current && activeTab !== 'non-set-top-box') {
      videoRef.current.pause();
    }
  }, [activeTab]);

  // Select language-specific assets statically imported above
  const oneBattlePoster = currentLang === 'en' ? oneBattlePosterEn : oneBattlePosterZh;
  const kitchenSoldierPoster = currentLang === 'en' ? kitchenSoldierPosterEn : kitchenSoldierPosterZh;
  const wickedPoster = currentLang === 'en' ? wickedPosterEn : wickedPosterZh;
  const houseDragonPoster = currentLang === 'en' ? houseDragonPosterEn : houseDragonPosterZh;

  const leftPosters = [
    supermanPoster,
    oneBattlePoster,
    kitchenSoldierPoster,
    harryPotterPoster,
    wickedPoster
  ];

  const rightPosters = [
    euphoriaPoster,
    thePittPoster,
    twlPoster,
    tlousPoster,
    houseDragonPoster
  ];

  const videoSrc = currentLang === 'en' ? videoSrcEn : videoSrcZh;
  const videoPosterSrc = currentLang === 'en' ? videoPosterSrcEn : videoPosterSrcZh;

  // Early return for non-logged-in users to exactly match design HTML hierarchy
  if (!nowSessionId) {
    return (
      <div className="page-wrapper max-activation-guide">
        <div className="hero-section">
          <div className="rail-container">
            <div className="wrapper goLeft">
              <div className="track" ref={leftTrackRef}>
                {leftPosters.map((src, index) => (
                  <div className="item" key={`left-orig-${index}`}><img src={src} alt="" /></div>
                ))}
                {leftPosters.map((src, index) => (
                  <div className="item" key={`left-clone-${index}`}><img src={src} alt="" /></div>
                ))}
              </div>
            </div>

            <div className="wrapper goRight">
              <div className="track" ref={rightTrackRef}>
                {rightPosters.map((src, index) => (
                  <div className="item" key={`right-orig-${index}`}><img src={src} alt="" /></div>
                ))}
                {rightPosters.map((src, index) => (
                  <div className="item" key={`right-clone-${index}`}><img src={src} alt="" /></div>
                ))}
              </div>
            </div>
          </div>

          <div className="content-wrapper">
            <div className="content">
              <h2>{translations[currentLang].maxActiviateMaxAccount}</h2>
              <p>{translations[currentLang].maxHeroDesc}</p>
              <button className="btn primary" onClick={handleLogonButtonClick}>
                {translations[currentLang].maxLogin}
              </button>
              <div className="setup-nowid">
                <p>{translations[currentLang].maxHavenGotNowID}</p>
                <a onClick={handleFindYourSubscriptionClick} className="btn outline">
                  {translations[currentLang].maxSetupLinkNowID}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="activation-guide-section">
          <div className="container">
            <h2>{translations[currentLang].maxDetailProcedure}</h2>

            <div className="tab-button">
              <button className={activeTab === 'h1h2stb' ? 'active' : ''} onClick={() => setActiveTab('h1h2stb')}>
                {translations[currentLang].maxTabH1H2}<span className="nowrap">{translations[currentLang].maxSetTopBox}</span>
              </button>
              <button className={activeTab === 'otherbox' ? 'active' : ''} onClick={() => setActiveTab('otherbox')}>
                {translations[currentLang].maxTabOtherBox}<span className="nowrap">{translations[currentLang].maxTabOtherBoxSpan}</span>
              </button>   
              <button className={activeTab === 'non-set-top-box' ? 'active' : ''} onClick={() => setActiveTab('non-set-top-box')}>
                {translations[currentLang].maxTabNonSTB}<span class="nowrap">{translations[currentLang].maxBoxUser}</span>
              </button>
            </div>

            {activeTab === 'h1h2stb' && (
              <div className="boxModel">
                <div className="boxModel-button">
                  <button className={boxModelOpen ? 'active' : ''} onClick={() => setBoxModelOpen(!boxModelOpen)}>
                    {translations[currentLang].maxNotSureModel}
                  </button>
                </div>

                <div className={`boxes-wrapper ${boxModelOpen ? 'open' : ''}`}>
                  <div className="item">
                    <h4>{translations[currentLang].maxH1BoxTitle}</h4>
                    <img src={nowh1box} alt="" />
                    <p>{translations[currentLang].maxH1BoxDesc}</p>
                  </div>

                  <div className="item">
                    <h4>{translations[currentLang].maxH2BoxTitle}</h4>
                    <img src={nowh2box} alt="" />
                    <p>{translations[currentLang].maxH2BoxDesc}</p>
                  </div>

                      
                  <button
                    type="button"
                    className="link"
                     onClick={() => setActiveTab('otherbox')}
                   >
                    {translations[currentLang].maxHaveDiffBox}
                  </button>
                </div>
              </div>
            )}

            <div className="video-wrapper">
              <div
                className="video-container"
                style={{ display: activeTab === 'non-set-top-box' ? 'block' : 'none' }}
              >
                <video
                  ref={videoRef}
                  src={videoSrc}
                  poster={videoPosterSrc}
                  controls
                  disablePictureInPicture
                  controlsList="noplaybackrate nodownload"
                />
              </div>
              <div className="steps-wrapper">
                {/* tab h1h2stb */}
                {activeTab === 'h1h2stb' && (
                  <ul className="active">
                    <li className="active">
                      {translations[currentLang].maxStepH1H2_1_1}
                      {translations[currentLang].maxStepH1H2_1_bold && <b>{translations[currentLang].maxStepH1H2_1_bold}</b>}
                      {translations[currentLang].maxStepH1H2_1_2}
                    </li>
                    <li>{translations[currentLang].maxStepH1H2_2}</li>
                    <li>{translations[currentLang].maxStepH1H2_3}</li>
                    <li>
                      {translations[currentLang].maxStepH1H2_4_1}
                      {translations[currentLang].maxStepH1H2_4_bold && <b>{translations[currentLang].maxStepH1H2_4_bold}</b>}
                      {translations[currentLang].maxStepH1H2_4_2}<br /><br /><br />{translations[currentLang].maxStepH1H2_4_3}
                    </li>
                  </ul>
                )}

                {/* tab otherbox */}
                {activeTab === 'otherbox' && (
                  <ul className="active">
                    <li className="active">{translations[currentLang].maxStepOther_1}</li>
                    <li>{translations[currentLang].maxStepOther_2}</li>
                    <li>{translations[currentLang].maxStepOther_NonSTB_3}</li>
                    <li>{translations[currentLang].maxOnceCompleted}</li>
                  </ul>
                )}

                {/* tab non-set-top-box */}
                {activeTab === 'non-set-top-box' && (
                  <ul className="active">
                    <li className="active">
                      {translations[currentLang].maxStepNonSTB_1_prefix}
                      <button onClick={handleLogonButtonClick} className="link underline">{translations[currentLang].maxLogin}</button>
                      {translations[currentLang].maxStepNonSTB_1_suffix}
                    </li>
                    <li>{translations[currentLang].maxStepNonSTB_2}</li>
                    <li>{translations[currentLang].maxStepOther_NonSTB_3}</li>
                    <li>{translations[currentLang].maxOnceCompleted}</li>
                  </ul>
                )}
              </div>
            </div>

            <div className="dlhbomax-wrapper">
              <div className="app">
                <img src={hbomaxAppLogo} alt="" />
                <h4>{translations[currentLang].maxDownloadAndWatch}</h4>
              </div>
              <p>{translations[currentLang].maxAvailableDevices}</p>
              <img src={hbomaxDevices} alt="" className="img-devices" />
              <a onClick={handleSupportedDevicesClick} className="link new-window">{translations[currentLang].maxDetailOnSupportedDevices}</a>
              <small>{translations[currentLang].maxSmallNote}</small>
            </div>

            {(activeTab === 'otherbox' || activeTab === 'non-set-top-box') && (
              <div className="download-nowtv">
                <div className="container">
                  <h4>{translations[currentLang].maxMoreEntApp}</h4>

                  <div className="nowtv-apps-wrapper">
                    <div className="apps-wrapper">
                      <div className="nowtv-app">
                        <img src={nowTVAppIcon} alt="" />
                      </div>
                      <div className="app-labels-wrapper">
                        <div className="download-section mobile">
                          <h4>{translations[currentLang].maxOnMobileDevice}</h4>
                          {(deviceType === 'ios' || deviceType === 'desktop') && (
                            <a href="https://apps.apple.com/hk/app/now-%E9%9A%A8%E8%BA%AB%E7%9D%87/id501956183?l=en" target="_blank" rel="noopener noreferrer"><img src={iOSAppStoreImg} alt="" /></a>
                           )}
                           {(deviceType === 'android' || deviceType === 'desktop') && (
                            <a href="https://play.google.com/store/apps/details?id=com.pccw.nowplayer&hl=en" target="_blank" rel="noopener noreferrer"><img src={googlePlayStoreImg} alt="" /></a>
                           )}
                        </div>
                        <div className="download-section tv">
                          <h4>{translations[currentLang].maxOnSmartTV}</h4>
                          <img src={samsungTizenImg} alt="" className="samsung" />
                          <img src={LGSmartTVImg} alt="" className="lg" />
                          <img src={androidtvtvImg} alt="" className="android" />
                          <img src={PanasonicFiretvImg} alt="" className="firetv" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="noweUser">
              <h6>{translations[currentLang].maxNowEUser}</h6>
              <p>
                {translations[currentLang].maxLearnMore1}
                <a onClick={handleLearnMoreHereClick}>
                  {translations[currentLang].maxLearnMore2}
                </a>
                {translations[currentLang]. maxLearnMore3}
              </p>
            </div>
          </div>
        </div>

        <div className="branding-section">
          <div className="container">
            <p>{translations[currentLang].maxBrandingText}</p>
            <div className="logos-wrapper">
              <img src={hboLogo} alt="" className="hbo" />
              <img src={warnerLogo} alt="" className="Warner_Bros" />
              <img src={dcLogo} alt="" className="dc" />
              <img src={universalLogo} alt="" className="universal" />
              <img src={paramountLogo} alt="" className="paramount" />
              <img src={harryPotterLogo} alt="" className="harry_Potter" />
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Layout for logged-in users
  return (
    <div className="page-wrapper">
      <div className="container">
        <div className="max-wrapper">
          {loading && (
            <>
              <div className="name">
                <h2 className="name">{translations[currentLang].maxSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].maxSubjectGreeting2}</h2>
              </div>
              <div className="loading-wrapper show inline">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </>
          )}
          {subscribedInd === 'N' && (
            <div className="heading">
               <h2>{translations[currentLang].maxSubscriptionNotFound}</h2>
           </div>
          )}
          {(subscribedInd === 'Y' && activationStatus === 'Activated') && (
            <MaxActivated
              currentLang={currentLang}
              nickname={nickname}
              mobilenowid={mobilenowid}
              emailnowid={emailnowid}
            />
          )}
          {(subscribedInd === 'Y' && activationStatus === 'Enrolled') && (
            <MaxNotActivated
              currentLang={currentLang}
              nickname={nickname}
              mobilenowid={mobilenowid}
              emailnowid={emailnowid}
              fsa={fsa}
              fsaType={fsaType}
            />
          )}
          {(subscribedInd === 'Y' && activationStatus !== 'Activated' && activationStatus !== 'Enrolled') && (
            <>
              <div className="name">
                <h2 className="name">{translations[currentLang].maxSubjectGreeting}{nickname || mobilenowid || emailnowid}{translations[currentLang].maxSubjectGreeting2}</h2>
              </div>
              <div className="preview-img">
                <img src={maxActivationImage} alt="" />
              </div>
            </>
          )}
          {(!loading && (subscribedInd !== 'N' && subscribedInd !== 'Y')) && (
            <MaxError
              currentLang={currentLang}
              nickname={nickname}
              mobilenowid={mobilenowid}
              emailnowid={emailnowid}
            />
          )}
        </div>
      </div>
      {!loading && subscribedInd === 'N' && (
          <MaxEnquiry
              currentLang={currentLang}
              mobilenowid={mobilenowid}
              emailnowid={emailnowid}
              learnMoreUrl={learnMoreUrl}
              isEmailVerified={isEmailVerified}
              loginUrl={loginUrl}
          />
      )}
    </div>
  );
};

export default Max;